/* eslint-disable max-len */
import {SERVICE_NAMES} from '../constants';
import {createApiCall} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    ValidateEmailRequest,
    ValidatePhoneRequest,
    StoreRegistrationRequest,
    RegistrationTokenResource,
    ConfirmEmailRequest,
    VerifySmsRequest,
    ResendSmsRequest,
    CompleteRegistrationRequest,
    OAuthTokenResource,
    RegistrationStatusResource,
    DomainResource,
    StoreDomainRequest,
    UpdateDomainRequest
} from './api.d';

const createRegistrationApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.REGISTRATION as ServiceName, method, endpoint);

export const registrationApi = {
    // All registration endpoints use S2S auth because user is not authenticated yet
    validateEmail: ({data, options}: {data: ValidateEmailRequest; options?: ApiCallOptions}) => createRegistrationApiCall<void>('POST', 'registrations/validate/email')({...options, data, useS2SAuth: true}),

    validatePhone: ({data, options}: {data: ValidatePhoneRequest; options?: ApiCallOptions}) => createRegistrationApiCall<void>('POST', 'registrations/validate/phone')({...options, data, useS2SAuth: true}),

    createRegistration: ({data, options}: {data: StoreRegistrationRequest; options?: ApiCallOptions}) => createRegistrationApiCall<RegistrationTokenResource>('POST', 'registrations')({...options, data, useS2SAuth: true}),

    getRegistrationStatus: ({registrationId, options}: {registrationId: string; options?: ApiCallOptions}) => createRegistrationApiCall<{data: RegistrationStatusResource}>('GET', `registrations/${registrationId}`)({...options, useS2SAuth: true}),

    confirmEmail: ({registrationId, data, options}: {registrationId: string; data: ConfirmEmailRequest; options?: ApiCallOptions}) => createRegistrationApiCall<void>('POST', `registrations/${registrationId}/verify-email`)({...options, data, useS2SAuth: true}),

    verifySms: ({registrationId, data, options}: {registrationId: string; data: VerifySmsRequest; options?: ApiCallOptions}) => createRegistrationApiCall<void>('POST', `registrations/${registrationId}/verify-sms`)({...options, data, useS2SAuth: true}),

    resendSms: ({registrationId, data, options}: {registrationId: string; data?: ResendSmsRequest; options?: ApiCallOptions}) => createRegistrationApiCall<void>('POST', `registrations/${registrationId}/resend-sms`)({...options, data, useS2SAuth: true}),

    completeRegistration: ({registrationId, data, options}: {registrationId: string; data: CompleteRegistrationRequest; options?: ApiCallOptions}) => createRegistrationApiCall<OAuthTokenResource>('POST', `registrations/${registrationId}/complete`)({...options, data, useS2SAuth: true}),

    getExcludedDomains: ({options}: {options?: ApiCallOptions} = {}) => createRegistrationApiCall<{data: DomainResource[]}>('GET', 'excluded-domains')({...options}),

    createExcludedDomain: ({data, options}: {data: StoreDomainRequest; options?: ApiCallOptions}) => createRegistrationApiCall<{data: DomainResource}>('POST', 'excluded-domains')({...options, data}),

    getExcludedDomain: ({domainId, options}: {domainId: string; options?: ApiCallOptions}) => createRegistrationApiCall<{data: DomainResource}>('GET', `excluded-domains/${domainId}`)({...options}),

    updateExcludedDomain: ({domainId, data, options}: {domainId: string; data: UpdateDomainRequest; options?: ApiCallOptions}) => createRegistrationApiCall<{data: DomainResource}>('PUT', `excluded-domains/${domainId}`)({...options, data}),

    deleteExcludedDomain: ({domainId, options}: {domainId: string; options?: ApiCallOptions}) => createRegistrationApiCall<void>('DELETE', `excluded-domains/${domainId}`)({...options}),

    getWhitelistedDomains: ({options}: {options?: ApiCallOptions} = {}) => createRegistrationApiCall<{data: DomainResource[]}>('GET', 'whitelisted-domains')({...options}),

    createWhitelistedDomain: ({data, options}: {data: StoreDomainRequest; options?: ApiCallOptions}) => createRegistrationApiCall<{data: DomainResource}>('POST', 'whitelisted-domains')({...options, data}),

    getWhitelistedDomain: ({domainId, options}: {domainId: string; options?: ApiCallOptions}) => createRegistrationApiCall<{data: DomainResource}>('GET', `whitelisted-domains/${domainId}`)({...options}),

    updateWhitelistedDomain: ({domainId, data, options}: {domainId: string; data: UpdateDomainRequest; options?: ApiCallOptions}) => createRegistrationApiCall<{data: DomainResource}>('PUT', `whitelisted-domains/${domainId}`)({...options, data}),

    deleteWhitelistedDomain: ({domainId, options}: {domainId: string; options?: ApiCallOptions}) => createRegistrationApiCall<void>('DELETE', `whitelisted-domains/${domainId}`)({...options})
};
